/*
 * @Author: llzq
 * @Date: 2021-10-24 13:32:01
 * @Email: liuzhiqiang1@jd.com
 * @LastEditors: llzq
 * @LastEditTime: 2021-10-24 13:46:47
 * @Description:  头部注释
 */
import React, { Component } from "react";
import {Card,Checkbox,Icon,Spin} from "antd";
import Organization from "./models/organization";
import AppService from "../service/app.service";
import PersonItem from "./models/personItem";

interface iProps {
  organization: Organization;
  onCancel: Function;
  onCheck: Function;
  personUrl?: string
}
interface iState {
  personItemList: PersonItem[];
  loading: boolean;
}
export default class PersonList extends Component<iProps, iState> {
  private appService: AppService = new AppService();
  state: iState = {
    personItemList: [],
    loading: false,
  };
  goBack = () => {
    this.props.onCancel();
  };
  loadData = async () => {
    let {
      id: organizationId = "",
      selectType = "",
      organizationType = "PERSON",
    } = this.props.organization;
    let personItemList = await this.appService.getOrganizationPersonList({
      organizationId,
      selectType,
      organizationType,
      personUrl: this.props.personUrl || ''
    });
    await this.setState({ personItemList });
  };
  onCheck = (checkedValues: string[]) => {
    let list = this.state.personItemList.filter((personItem) =>
      checkedValues.includes(personItem.id)
    );
    this.props.organization.viewSubItems=list
    this.props.onCheck(list);
  };
  async componentDidMount() {
    this.setState({ loading: true });
    await this.loadData();
    this.setState({ loading: false });
  }
  get checked(){
    return this.props.organization.viewSubItems.map(personItem=>personItem.id)
  }
  render() {
    return (
      <div style={{width:"100%",backgroundColor:"#fff",height:274,position:"absolute",left:0,top:0}}>
      <Card
        size="small"
        title={
          <div style={{ width: 40,cursor:"pointer" }} onClick={this.goBack}>
            <Icon type="left" />
            返回
          </div>
        }
        bodyStyle={{ paddingRight: 0 }}
        extra={this.props.organization.name}
        headStyle={{ borderBottom: "none" }}
        style={{
          width: 341,
          height: 274,
          position: "absolute",
          left: 16,
          top: 9,
        }}
      >
        <Spin spinning={this.state.loading} tip="加载中..." size="large">
          <div style={{ height: 224, overflowY: "auto" }}>
            <Checkbox.Group value={this.checked} style={{ width: "100%" }} onChange={this.onCheck}>
              {this.state.personItemList.map((personItem, index) => (
                <div key={index} style={{marginBottom:7}}>
                  <Checkbox value={personItem.id} className="personItem">
                    <div className="wrap">
                      <div className="name">{personItem.name}</div>
                      <div className="number">{personItem.no}</div>
                    </div>
                  </Checkbox>
                </div>
              ))}
            </Checkbox.Group>
          </div>
        </Spin>
      </Card>
      </div>
    );
  }
}
